

import { ADD_APPOINTMENT_LOCATION_TYPE_ERROR, ADD_APPOINTMENT_LOCATION_TYPE_SUCCESS, ADD_APPOINTMENT_PRIORITY_ERROR, ADD_APPOINTMENT_PRIORITY_SUCCESS, ADD_APPOINTMENT_TYPE_ERROR, ADD_APPOINTMENT_TYPE_SUCCESS, ADD_CONTACT_LEVEL_ERROR, ADD_CONTACT_LEVEL_SUCCESS, ADD_CONTACT_STATUS_ERROR, ADD_CONTACT_STATUS_SUCCESS, ADD_CONTACT_TYPE_ERROR, ADD_CONTACT_TYPE_SUCCESS, ADD_LEAD_CLASSIFICATION_ERROR, ADD_LEAD_CLASSIFICATION_SUCCESS, ADD_LEAD_SOURCE_ERROR, ADD_LEAD_SOURCE_SUCCESS, ADD_LEAD_STAGE_ERROR, ADD_LEAD_STAGE_SUCCESS, ADD_LEAD_STATUS_ERROR, ADD_LEAD_STATUS_SUCCESS, ADD_LEAD_TYPE_ERROR, ADD_LEAD_TYPE_SUCCESS, ADD_NOTE_TYPE_ERROR, ADD_NOTE_TYPE_SUCCESS, ADD_PROJECT_DOCUMENT_TYPE_ERROR, ADD_PROJECT_DOCUMENT_TYPE_SUCCESS, ADD_PROJECT_STATUS_ERROR, ADD_PROJECT_STATUS_SUCCESS, ADD_PROJECT_TYPE_ERROR, ADD_PROJECT_TYPE_SUCCESS, ADD_SERVICE_TYPE_ERROR, ADD_SERVICE_TYPE_SUCCESS, ADD_TASK_PRIORITY_ERROR, ADD_TASK_PRIORITY_SUCCESS, ADD_TASK_REMINDER_ERROR, ADD_TASK_REMINDER_SUCCESS, ADD_TASK_STATUS_ERROR, ADD_TASK_STATUS_SUCCESS, ADD_TASK_TYPE_ERROR, ADD_TASK_TYPE_SUCCESS, ADD_TRANSACTION_COMMISSION_TYPE_ERROR, ADD_TRANSACTION_COMMISSION_TYPE_SUCCESS, ADD_TRANSACTION_REF_TYPE_ERROR, ADD_TRANSACTION_REF_TYPE_SUCCESS, ADD_TRANSACTION_STATUS_TYPE_ERROR, ADD_TRANSACTION_STATUS_TYPE_SUCCESS, ADD_TRANSACTION_TYPE_ERROR, ADD_TRANSACTION_TYPE_SUCCESS, DELETE_APPOINTMENT_LOCATION_TYPE_ERROR, DELETE_APPOINTMENT_LOCATION_TYPE_SUCCESS, DELETE_APPOINTMENT_PRIORITY_ERROR, DELETE_APPOINTMENT_PRIORITY_SUCCESS, DELETE_APPOINTMENT_TYPE_ERROR, DELETE_APPOINTMENT_TYPE_SUCCESS, DELETE_CONTACT_LEVEL_ERROR, DELETE_CONTACT_LEVEL_SUCCESS, DELETE_CONTACT_STATUS_ERROR, DELETE_CONTACT_STATUS_SUCCESS, DELETE_CONTACT_TYPE_ERROR, DELETE_CONTACT_TYPE_SUCCESS, DELETE_LEAD_CLASSIFICATION_ERROR, DELETE_LEAD_CLASSIFICATION_SUCCESS, DELETE_LEAD_SOURCE_ERROR, DELETE_LEAD_SOURCE_SUCCESS, DELETE_LEAD_STAGE_SUCCESS, DELETE_LEAD_STATUS_ERROR, DELETE_LEAD_STATUS_SUCCESS, DELETE_LEAD_TYPE, DELETE_LEAD_TYPE_ERROR, DELETE_LEAD_TYPE_SUCCESS, DELETE_NOTE_TYPE_ERROR, DELETE_NOTE_TYPE_SUCCESS, DELETE_PROJECT_DOCUMENT_TYPE_ERROR, DELETE_PROJECT_DOCUMENT_TYPE_SUCCESS, DELETE_PROJECT_STATUS_ERROR, DELETE_PROJECT_STATUS_SUCCESS, DELETE_PROJECT_TYPE_ERROR, DELETE_PROJECT_TYPE_SUCCESS, DELETE_SERVICE_TYPE_ERROR, DELETE_SERVICE_TYPE_SUCCESS, DELETE_TASK_PRIORITY_ERROR, DELETE_TASK_PRIORITY_SUCCESS, DELETE_TASK_REMINDER_ERROR, DELETE_TASK_REMINDER_SUCCESS, DELETE_TASK_STATUS_ERROR, DELETE_TASK_STATUS_SUCCESS, DELETE_TASK_TYPE_ERROR, DELETE_TASK_TYPE_SUCCESS, DELETE_TRANSACTION_COMMISSION_TYPE_ERROR, DELETE_TRANSACTION_COMMISSION_TYPE_SUCCESS, DELETE_TRANSACTION_REF_TYPE_ERROR, DELETE_TRANSACTION_REF_TYPE_SUCCESS, DELETE_TRANSACTION_STATUS_TYPE_ERROR, DELETE_TRANSACTION_STATUS_TYPE_SUCCESS, DELETE_TRANSACTION_TYPE_ERROR, DELETE_TRANSACTION_TYPE_SUCCESS, GET_APP_BY_PAGE_TYPE, GET_APP_BY_PAGE_TYPE_FAIL, GET_APP_BY_PAGE_TYPE_SUCCESS, GET_APPOINTMENT_LOCATION_TYPE, GET_APPOINTMENT_LOCATION_TYPE_FAIL, GET_APPOINTMENT_LOCATION_TYPE_SUCCESS, GET_APPOINTMENT_PRIORITY, GET_APPOINTMENT_PRIORITY_FAIL, GET_APPOINTMENT_PRIORITY_SUCCESS, GET_APPOINTMENT_TYPE, GET_APPOINTMENT_TYPE_FAIL, GET_APPOINTMENT_TYPE_SUCCESS, GET_CAMPAIGN_EMAIL_LIST, GET_CAMPAIGN_EMAIL_LIST_ERROR, GET_CAMPAIGN_EMAIL_LIST_SUCCESS, GET_CONTACT_LEVEL, GET_CONTACT_LEVEL_FAIL, GET_CONTACT_LEVEL_SUCCESS, GET_CONTACT_STATUS, GET_CONTACT_STATUS_FAIL, GET_CONTACT_STATUS_SUCCESS, GET_CONTACT_TYPE, GET_CONTACT_TYPE_FAIL, GET_CONTACT_TYPE_SUCCESS, GET_EMAIL_LIST_TARGET, GET_EMAIL_LIST_TARGET_ERROR, GET_EMAIL_LIST_TARGET_SUCCESS, GET_EMAIL_LIST_TYPE, GET_EMAIL_LIST_TYPE_ERROR, GET_EMAIL_LIST_TYPE_SUCCESS, GET_LEAD_CLASSIFICATION, GET_LEAD_CLASSIFICATION_FAIL, GET_LEAD_CLASSIFICATION_SUCCESS, GET_LEAD_SOURCE, GET_LEAD_SOURCE_FAIL, GET_LEAD_SOURCE_SUCCESS, GET_LEAD_STAGE, GET_LEAD_STAGE_FAIL, GET_LEAD_STAGE_SUCCESS, GET_LEAD_STATUS, GET_LEAD_STATUS_FAIL, GET_LEAD_STATUS_SUCCESS, GET_LEAD_TYPE, GET_LEAD_TYPE_FAIL, GET_LEAD_TYPE_SUCCESS, GET_LISTING_STATUS, GET_LISTING_STATUS_ERROR, GET_LISTING_STATUS_SUCCESS, GET_LISTING_TYPE, GET_LISTING_TYPE_FAIL, GET_LISTING_TYPE_SUCCESS, GET_NOTE_TYPE, GET_NOTE_TYPE_FAIL, GET_NOTE_TYPE_SUCCESS, GET_PROJECT_DOCUMENT_TYPE, GET_PROJECT_DOCUMENT_TYPE_FAIL, GET_PROJECT_DOCUMENT_TYPE_SUCCESS, GET_PROJECT_STATUS, GET_PROJECT_STATUS_FAIL, GET_PROJECT_STATUS_SUCCESS, GET_PROJECT_TYPE, GET_PROJECT_TYPE_FAIL, GET_PROJECT_TYPE_SUCCESS, GET_SERVICE_TYPE, GET_SERVICE_TYPE_FAIL, GET_SERVICE_TYPE_SUCCESS, GET_SHOWING_STATUS, GET_SHOWING_STATUS_ERROR, GET_SHOWING_STATUS_SUCCESS, GET_TASK_PRIORITY, GET_TASK_PRIORITY_FAIL, GET_TASK_PRIORITY_SUCCESS, GET_TASK_REMINDER, GET_TASK_REMINDER_FAIL, GET_TASK_REMINDER_SUCCESS, GET_TASK_STATUS, GET_TASK_STATUS_FAIL, GET_TASK_STATUS_SUCCESS, GET_TASK_TYPE, GET_TASK_TYPE_FAIL, GET_TASK_TYPE_SUCCESS, GET_TRANSACTION_COMMISSION_TYPE, GET_TRANSACTION_COMMISSION_TYPE_FAIL, GET_TRANSACTION_COMMISSION_TYPE_SUCCESS, GET_TRANSACTION_REF_TYPE, GET_TRANSACTION_REF_TYPE_FAIL, GET_TRANSACTION_REF_TYPE_SUCCESS, GET_TRANSACTION_STATUS_TYPE, GET_TRANSACTION_STATUS_TYPE_FAIL, GET_TRANSACTION_STATUS_TYPE_SUCCESS, GET_TRANSACTION_TYPE, GET_TRANSACTION_TYPE_FAIL, GET_TRANSACTION_TYPE_SUCCESS, UPDATE_APPOINTMENT_LOCATION_TYPE_FAIL, UPDATE_APPOINTMENT_LOCATION_TYPE_SUCCESS, UPDATE_APPOINTMENT_PRIORITY_FAIL, UPDATE_APPOINTMENT_PRIORITY_SUCCESS, UPDATE_APPOINTMENT_TYPE_FAIL, UPDATE_APPOINTMENT_TYPE_SUCCESS, UPDATE_CONTACT_LEVEL_FAIL, UPDATE_CONTACT_LEVEL_SUCCESS, UPDATE_CONTACT_STATUS_FAIL, UPDATE_CONTACT_STATUS_SUCCESS, UPDATE_CONTACT_TYPE_FAIL, UPDATE_CONTACT_TYPE_SUCCESS, UPDATE_LEAD_CLASSIFICATION_FAIL, UPDATE_LEAD_CLASSIFICATION_SUCCESS, UPDATE_LEAD_SOURCE_FAIL, UPDATE_LEAD_SOURCE_SUCCESS, UPDATE_LEAD_STAGE_SUCCESS, UPDATE_LEAD_STATUS_FAIL, UPDATE_LEAD_STATUS_SUCCESS, UPDATE_LEAD_TYPE_FAIL, UPDATE_LEAD_TYPE_SUCCESS, UPDATE_NOTE_TYPE_FAIL, UPDATE_NOTE_TYPE_SUCCESS, UPDATE_PROJECT_DOCUMENT_TYPE_FAIL, UPDATE_PROJECT_DOCUMENT_TYPE_SUCCESS, UPDATE_PROJECT_STATUS_FAIL, UPDATE_PROJECT_STATUS_SUCCESS, UPDATE_PROJECT_TYPE_FAIL, UPDATE_PROJECT_TYPE_SUCCESS, UPDATE_SERVICE_TYPE_FAIL, UPDATE_SERVICE_TYPE_SUCCESS, UPDATE_TASK_PRIORITY_FAIL, UPDATE_TASK_PRIORITY_SUCCESS, UPDATE_TASK_REMINDER_FAIL, UPDATE_TASK_STATUS_FAIL, UPDATE_TASK_STATUS_SUCCESS, UPDATE_TASK_TYPE_FAIL, UPDATE_TASK_TYPE_SUCCESS, UPDATE_TRANSACTION_COMMISSION_TYPE_FAIL, UPDATE_TRANSACTION_COMMISSION_TYPE_SUCCESS, UPDATE_TRANSACTION_REF_TYPE_FAIL, UPDATE_TRANSACTION_REF_TYPE_SUCCESS, UPDATE_TRANSACTION_STATUS_TYPE_FAIL, UPDATE_TRANSACTION_STATUS_TYPE_SUCCESS, UPDATE_TRANSACTION_TYPE_FAIL, UPDATE_TRANSACTION_TYPE_SUCCESS } from "./actionTypes"

const initialState = {
  error: "",
  loading: true,
  locationTypes: [],
  priorities: [],
  types: [],
  levels: [],
  statuses: [],
  leadclasses: [],
  leadsources: [],
  contacttypes: [],
  leadstatuses: [],
  leadtypes: [],
  notetypes: [],
  doctypes: [],
  docstatuses: [],
  leadstages: []
}

const AppoinmentObject = (state = initialState, action) => {
  switch (action.type) {
    case ADD_APPOINTMENT_LOCATION_TYPE_SUCCESS:
      state = { ...state, loading: false }
      break
    case ADD_APPOINTMENT_LOCATION_TYPE_ERROR:
      state = { ...state, error: action.payload, loading: false }
      break
    case GET_APPOINTMENT_LOCATION_TYPE:
      return { ...state, loading: true }
    case GET_APPOINTMENT_LOCATION_TYPE_SUCCESS:
      return { ...state, locationTypes: action.payload, loading: false }
    case GET_APPOINTMENT_LOCATION_TYPE_FAIL:
      return { ...state, error: action.payload, loading: false }
    case DELETE_APPOINTMENT_LOCATION_TYPE_SUCCESS:
      return { ...state, locationType: action.payload }
    case DELETE_APPOINTMENT_LOCATION_TYPE_ERROR:
      return { ...state, error: action.payload }
    case ADD_APPOINTMENT_PRIORITY_SUCCESS:
      state = { ...state, loading: false }
      break
    case ADD_APPOINTMENT_PRIORITY_ERROR:
      state = { ...state, error: action.payload, loading: false }
      break
    case GET_APPOINTMENT_PRIORITY:
      return { ...state, loading: true }
    case GET_APPOINTMENT_PRIORITY_SUCCESS:
      return { ...state, priorities: action.payload, loading: false }
    case GET_APPOINTMENT_PRIORITY_FAIL:
      return { ...state, error: action.payload, loading: false }
    case UPDATE_APPOINTMENT_PRIORITY_SUCCESS:
      return {
        ...state,
        priorities: state.priorities.map(priority =>
          priority.id.toString() === action.payload.id.toString()
            ? { priority, ...action.payload }
            : priority
        ),
      }
    case UPDATE_APPOINTMENT_PRIORITY_FAIL:
      return { ...state, error: action.payload }
    case DELETE_APPOINTMENT_PRIORITY_SUCCESS:
      return { ...state, priority: action.payload }
    case DELETE_APPOINTMENT_PRIORITY_ERROR:
      return { ...state, error: action.payload }
    case ADD_APPOINTMENT_TYPE_SUCCESS:
      state = { ...state, loading: false }
      break
    case ADD_APPOINTMENT_TYPE_ERROR:
      state = { ...state, error: action.payload, loading: false }
      break
    case GET_APPOINTMENT_TYPE:
      return { ...state, loading: true }
    case GET_APPOINTMENT_TYPE_SUCCESS:
      return { ...state, types: action.payload, loading: false }
    case GET_APPOINTMENT_TYPE_FAIL:
      return { ...state, error: action.payload, loading: false }
    case UPDATE_APPOINTMENT_TYPE_SUCCESS:
      return {
        ...state,
        types: state.types.map(type =>
          type.id.toString() === action.payload.id.toString()
            ? { type, ...action.payload }
            : type
        ),
      }
    case UPDATE_APPOINTMENT_TYPE_FAIL:
      return { ...state, error: action.payload }
    case DELETE_APPOINTMENT_TYPE_SUCCESS:
      return { ...state, type: action.payload }
    case DELETE_APPOINTMENT_TYPE_ERROR:
      return { ...state, error: action.payload }
    case ADD_CONTACT_LEVEL_SUCCESS:
      state = { ...state, loading: false }
      break
    case ADD_CONTACT_LEVEL_ERROR:
      state = { ...state, error: action.payload, loading: false }
      break
    case GET_CONTACT_LEVEL:
      return { ...state, loading: true }
    case GET_CONTACT_LEVEL_SUCCESS:
      return { ...state, levels: action.payload, loading: false }
    case GET_CONTACT_LEVEL_FAIL:
      return { ...state, error: action.payload, loading: false }
    case UPDATE_CONTACT_LEVEL_SUCCESS:
      return {
        ...state,
        levels: state.levels.map(level =>
          level.id.toString() === action.payload.id.toString()
            ? { level, ...action.payload }
            : level
        ),
      }
    case UPDATE_CONTACT_LEVEL_FAIL:
      return { ...state, error: action.payload }
    case DELETE_CONTACT_LEVEL_SUCCESS:
      return { ...state, type: action.payload }
    case DELETE_CONTACT_LEVEL_ERROR:
      return { ...state, error: action.payload }

    case ADD_CONTACT_STATUS_SUCCESS:
      state = { ...state, loading: false }
      break
    case ADD_CONTACT_STATUS_ERROR:
      state = { ...state, error: action.payload, loading: false }
      break
    case GET_CONTACT_STATUS:
      return { ...state, loading: true }
    case GET_CONTACT_STATUS_SUCCESS:
      return { ...state, statuses: action.payload, loading: false }
    case GET_CONTACT_STATUS_FAIL:
      return { ...state, error: action.payload, loading: false }
    case UPDATE_CONTACT_STATUS_SUCCESS:
      return {
        ...state,
        statuses: state.statuses.map(status =>
          status.id.toString() === action.payload.id.toString()
            ? { status, ...action.payload }
            : status
        ),
      }
    case UPDATE_CONTACT_STATUS_FAIL:
      return { ...state, error: action.payload }
    case DELETE_CONTACT_STATUS_SUCCESS:
      return { ...state, type: action.payload }
    case DELETE_CONTACT_STATUS_ERROR:
      return { ...state, error: action.payload }
    case ADD_CONTACT_TYPE_SUCCESS:
      state = { ...state, loading: false }
      break
    case ADD_CONTACT_TYPE_ERROR:
      state = { ...state, error: action.payload, loading: false }
      break
    case GET_CONTACT_TYPE:
      return { ...state, loading: true }
    case GET_CONTACT_TYPE_SUCCESS:
      return { ...state, contacttypes: action.payload, loading: false }
    case GET_CONTACT_TYPE_FAIL:
      return { ...state, error: action.payload, loading: false }
    case UPDATE_CONTACT_TYPE_SUCCESS:
      return {
        ...state,
        contacttypes: state.contacttypes.map(contacttype =>
          contacttype.id.toString() === action.payload.id.toString()
            ? { contacttype, ...action.payload }
            : contacttype
        ),
      }
    case UPDATE_CONTACT_TYPE_FAIL:
      return { ...state, error: action.payload }
    case DELETE_CONTACT_TYPE_SUCCESS:
      return { ...state, contacttype: action.payload }
    case DELETE_CONTACT_TYPE_ERROR:
      return { ...state, error: action.payload }

    case ADD_LEAD_CLASSIFICATION_SUCCESS:
      state = { ...state, loading: false }
      break
    case ADD_LEAD_CLASSIFICATION_ERROR:
      state = { ...state, error: action.payload, loading: false }
      break
    case GET_LEAD_CLASSIFICATION:
      return { ...state, loading: true }
    case GET_LEAD_CLASSIFICATION_SUCCESS:
      return { ...state, leadclasses: action.payload, loading: false }
    case GET_LEAD_CLASSIFICATION_FAIL:
      return { ...state, error: action.payload, loading: false }
    case UPDATE_LEAD_CLASSIFICATION_SUCCESS:
      return {
        ...state,
        leadclasses: state.leadclasses.map(leadclass =>
          leadclass.id.toString() === action.payload.id.toString()
            ? { leadclass, ...action.payload }
            : leadclass
        ),
      }
    case UPDATE_LEAD_CLASSIFICATION_FAIL:
      return { ...state, error: action.payload }
    case DELETE_LEAD_CLASSIFICATION_SUCCESS:
      return { ...state, leadclass: action.payload }
    case DELETE_LEAD_CLASSIFICATION_ERROR:
      return { ...state, error: action.payload }

    case ADD_LEAD_SOURCE_SUCCESS:
      state = { ...state, loading: false }
      break
    case ADD_LEAD_SOURCE_ERROR:
      state = { ...state, error: action.payload, loading: false }
      break
    case GET_LEAD_SOURCE:
      return { ...state, loading: true }
    case GET_LEAD_SOURCE_SUCCESS:
      return { ...state, leadsources: action.payload, loading: false }
    case GET_LEAD_SOURCE_FAIL:
      return { ...state, error: action.payload, loading: false }
    case UPDATE_LEAD_SOURCE_SUCCESS:
      return {
        ...state,
        leadsources: state.leadsources.map(leadsource =>
          leadsource.id.toString() === action.payload.id.toString()
            ? { leadsource, ...action.payload }
            : leadsource
        ),
      }
    case UPDATE_LEAD_SOURCE_FAIL:
      return { ...state, error: action.payload }
    case DELETE_LEAD_SOURCE_SUCCESS:
      return { ...state, leadsource: action.payload }
    case DELETE_LEAD_SOURCE_ERROR:
      return { ...state, error: action.payload }
    case ADD_LEAD_STATUS_SUCCESS:
      state = { ...state, loading: false }
      break
    case ADD_LEAD_STATUS_ERROR:
      state = { ...state, error: action.payload, loading: false }
      break
    case GET_LEAD_STATUS:
      return { ...state, loading: true }
    case GET_LEAD_STATUS_SUCCESS:
      return { ...state, leadstatuses: action.payload, loading: false }
    case GET_LEAD_STATUS_FAIL:
      return { ...state, error: action.payload, loading: false }
    case UPDATE_LEAD_STATUS_SUCCESS:
      return {
        ...state,
        leadstatuses: state.leadstatuses.map(leadstatus =>
          leadstatus.id.toString() === action.payload.id.toString()
            ? { leadstatus, ...action.payload }
            : leadstatus
        ),
      }
    case UPDATE_LEAD_STATUS_FAIL:
      return { ...state, error: action.payload }
    case DELETE_LEAD_STATUS_SUCCESS:
      return { ...state, leadstatus: action.payload }
    case DELETE_LEAD_STATUS_ERROR:
      return { ...state, error: action.payload }
    case ADD_LEAD_TYPE_SUCCESS:
      state = { ...state, loading: false }
      break
    case ADD_LEAD_TYPE_ERROR:
      state = { ...state, error: action.payload, loading: false }
      break
    case GET_LEAD_TYPE:
      return { ...state, loading: true }
    case GET_LEAD_TYPE_SUCCESS:
      return { ...state, leadtypes: action.payload, loading: false }
    case GET_LEAD_TYPE_FAIL:
      return { ...state, error: action.payload, loading: false }
    case UPDATE_LEAD_TYPE_SUCCESS:
      return {
        ...state,
        leadtypes: state.leadtypes.map(leadtype =>
          leadtype.id.toString() === action.payload.id.toString()
            ? { leadtype, ...action.payload }
            : leadtype
        ),
      }
    case UPDATE_LEAD_TYPE_FAIL:
      return { ...state, error: action.payload }
    case DELETE_LEAD_TYPE_SUCCESS:
      return { ...state, leadtype: action.payload }
    case DELETE_LEAD_TYPE_ERROR:
      return { ...state, error: action.payload }
    case ADD_NOTE_TYPE_SUCCESS:
      state = { ...state, loading: false }
      break
    case ADD_NOTE_TYPE_ERROR:
      state = { ...state, error: action.payload, loading: false }
      break
    case GET_NOTE_TYPE:
      return { ...state, loading: true }
    case GET_NOTE_TYPE_SUCCESS:
      return { ...state, notetypes: action.payload, loading: false }
    case GET_NOTE_TYPE_FAIL:
      return { ...state, error: action.payload, loading: false }
    case UPDATE_NOTE_TYPE_SUCCESS:
      return {
        ...state,
        notetypes: state.notetypes.map(notetype =>
          notetype.id.toString() === action.payload.id.toString()
            ? { notetype, ...action.payload }
            : notetype
        ),
      }
    case UPDATE_NOTE_TYPE_FAIL:
      return { ...state, error: action.payload }
    case DELETE_NOTE_TYPE_SUCCESS:
      return { ...state, notetype: action.payload }
    case DELETE_NOTE_TYPE_ERROR:
      return { ...state, error: action.payload }
    case ADD_PROJECT_DOCUMENT_TYPE_SUCCESS:
      state = { ...state, loading: false }
      break
    case ADD_PROJECT_DOCUMENT_TYPE_ERROR:
      state = { ...state, error: action.payload, loading: false }
      break
    case GET_PROJECT_DOCUMENT_TYPE:
      return { ...state, loading: true }
    case GET_PROJECT_DOCUMENT_TYPE_SUCCESS:
      return { ...state, doctypes: action.payload, loading: false }
    case GET_PROJECT_DOCUMENT_TYPE_FAIL:
      return { ...state, error: action.payload, loading: false }
    case UPDATE_PROJECT_DOCUMENT_TYPE_SUCCESS:
      return {
        ...state,
        doctypes: state.doctypes.map(doctype =>
          doctype.id.toString() === action.payload.id.toString()
            ? { doctype, ...action.payload }
            : doctype
        ),
      }
    case UPDATE_PROJECT_DOCUMENT_TYPE_FAIL:
      return { ...state, error: action.payload }
    case DELETE_PROJECT_DOCUMENT_TYPE_SUCCESS:
      return { ...state, doctype: action.payload }
    case DELETE_PROJECT_DOCUMENT_TYPE_ERROR:
      return { ...state, error: action.payload }
    case ADD_PROJECT_STATUS_SUCCESS:
      state = { ...state, loading: false }
      break
    case ADD_PROJECT_STATUS_ERROR:
      state = { ...state, error: action.payload, loading: false }
      break
    case GET_PROJECT_STATUS:
      return { ...state, loading: true }
    case GET_PROJECT_STATUS_SUCCESS:
      return { ...state, docstatuses: action.payload, loading: false }
    case GET_PROJECT_STATUS_FAIL:
      return { ...state, error: action.payload, loading: false }
    case UPDATE_PROJECT_STATUS_SUCCESS:
      return {
        ...state,
        docstatuses: state.docstatuses.map(docstatus =>
          docstatus.id.toString() === action.payload.id.toString()
            ? { docstatus, ...action.payload }
            : docstatus
        ),
      }
    case UPDATE_PROJECT_STATUS_FAIL:
      return { ...state, error: action.payload }
    case DELETE_PROJECT_STATUS_SUCCESS:
      return { ...state, docstatus: action.payload }
    case DELETE_PROJECT_STATUS_ERROR:
      return { ...state, error: action.payload }

    case ADD_PROJECT_TYPE_SUCCESS:
      state = { ...state, loading: false }
      break
    case ADD_PROJECT_TYPE_ERROR:
      state = { ...state, error: action.payload, loading: false }
      break
    case GET_PROJECT_TYPE:
      return { ...state, loading: true }
    case GET_PROJECT_TYPE_SUCCESS:
      return { ...state, protypes: action.payload, loading: false }
    case GET_PROJECT_TYPE_FAIL:
      return { ...state, error: action.payload, loading: false }
    case UPDATE_PROJECT_TYPE_SUCCESS:
      return {
        ...state,
        protypes: state.protypes.map(protype =>
          protype.id.toString() === action.payload.id.toString()
            ? { protype, ...action.payload }
            : protype
        ),
      }
    case UPDATE_PROJECT_TYPE_FAIL:
      return { ...state, error: action.payload }
    case DELETE_PROJECT_TYPE_SUCCESS:
      return { ...state, protype: action.payload }
    case DELETE_PROJECT_TYPE_ERROR:
      return { ...state, error: action.payload }
    case ADD_SERVICE_TYPE_SUCCESS:
      state = { ...state, loading: false }
      break
    case ADD_SERVICE_TYPE_ERROR:
      state = { ...state, error: action.payload, loading: false }
      break
    case GET_SERVICE_TYPE:
      return { ...state, loading: true }
    case GET_SERVICE_TYPE_SUCCESS:
      return { ...state, sertypes: action.payload, loading: false }
    case GET_SERVICE_TYPE_FAIL:
      return { ...state, error: action.payload, loading: false }
    case UPDATE_SERVICE_TYPE_SUCCESS:
      return {
        ...state,
        sertypes: state.sertypes.map(sertype =>
          sertype.id.toString() === action.payload.id.toString()
            ? { sertype, ...action.payload }
            : sertype
        ),
      }
    case UPDATE_SERVICE_TYPE_FAIL:
      return { ...state, error: action.payload }
    case DELETE_SERVICE_TYPE_SUCCESS:
      return { ...state, sertype: action.payload }
    case DELETE_SERVICE_TYPE_ERROR:
      return { ...state, error: action.payload }
    case ADD_TASK_PRIORITY_SUCCESS:
      state = { ...state, loading: false }
      break
    case ADD_TASK_PRIORITY_ERROR:
      state = { ...state, error: action.payload, loading: false }
      break
    case GET_TASK_PRIORITY:
      return { ...state, loading: true }
    case GET_TASK_PRIORITY_SUCCESS:
      return { ...state, taskpriorities: action.payload, loading: false }
    case GET_TASK_PRIORITY_FAIL:
      return { ...state, error: action.payload, loading: false }
    case UPDATE_TASK_PRIORITY_SUCCESS:
      return {
        ...state,
        taskpriorities: state.taskpriorities.map(taskpriority =>
          taskpriority.id.toString() === action.payload.id.toString()
            ? { taskpriority, ...action.payload }
            : taskpriority
        ),
      }
    case UPDATE_TASK_PRIORITY_FAIL:
      return { ...state, error: action.payload }
    case DELETE_TASK_PRIORITY_SUCCESS:
      return { ...state, taskpriority: action.payload }
    case DELETE_TASK_PRIORITY_ERROR:
      return { ...state, error: action.payload }
    case ADD_TASK_REMINDER_SUCCESS:
      state = { ...state, loading: false }
      break
    case ADD_TASK_REMINDER_ERROR:
      state = { ...state, error: action.payload, loading: false }
      break
    case GET_TASK_REMINDER:
      return { ...state, loading: true }
    case GET_TASK_REMINDER_SUCCESS:
      return { ...state, taskreminders: action.payload, loading: false }
    case GET_TASK_REMINDER_FAIL:
      return { ...state, error: action.payload, loading: false }
    case UPDATE_TASK_PRIORITY_SUCCESS:
      return {
        ...state,
        taskreminders: state.taskreminders.map(taskreminder =>
          taskreminder.id.toString() === action.payload.id.toString()
            ? { taskreminder, ...action.payload }
            : taskreminder
        ),
      }
    case UPDATE_TASK_REMINDER_FAIL:
      return { ...state, error: action.payload }
    case DELETE_TASK_REMINDER_SUCCESS:
      return { ...state, taskpriority: action.payload }
    case DELETE_TASK_REMINDER_ERROR:
      return { ...state, error: action.payload }

    case ADD_TASK_STATUS_SUCCESS:
      state = { ...state, loading: false }
      break
    case ADD_TASK_STATUS_ERROR:
      state = { ...state, error: action.payload, loading: false }
      break
    case GET_TASK_STATUS:
      return { ...state, loading: true }
    case GET_TASK_STATUS_SUCCESS:
      return { ...state, taskstatuses: action.payload, loading: false }
    case GET_TASK_STATUS_FAIL:
      return { ...state, error: action.payload, loading: false }
    case UPDATE_TASK_STATUS_SUCCESS:
      return {
        ...state,
        taskstatuses: state.taskstatuses.map(taskstatus =>
          taskstatus.id.toString() === action.payload.id.toString()
            ? { taskstatus, ...action.payload }
            : taskstatus
        ),
      }
    case UPDATE_TASK_STATUS_FAIL:
      return { ...state, error: action.payload }
    case DELETE_TASK_STATUS_SUCCESS:
      return { ...state, taskstatus: action.payload }
    case DELETE_TASK_STATUS_ERROR:
      return { ...state, error: action.payload }

    case ADD_TASK_TYPE_SUCCESS:
      state = { ...state, loading: false }
      break
    case ADD_TASK_TYPE_ERROR:
      state = { ...state, error: action.payload, loading: false }
      break
    case GET_TASK_TYPE:
      return { ...state, loading: true }
    case GET_TASK_TYPE_SUCCESS:
      return { ...state, tasktypes: action.payload, loading: false }
    case GET_TASK_TYPE_FAIL:
      return { ...state, error: action.payload, loading: false }
    case UPDATE_TASK_TYPE_SUCCESS:
      return {
        ...state,
        tasktypes: state.tasktypes.map(tasktype =>
          tasktype.id.toString() === action.payload.id.toString()
            ? { tasktype, ...action.payload }
            : tasktype
        ),
      }
    case UPDATE_TASK_TYPE_FAIL:
      return { ...state, error: action.payload }
    case DELETE_TASK_TYPE_SUCCESS:
      return { ...state, tasktype: action.payload }
    case DELETE_TASK_TYPE_ERROR:
      return { ...state, error: action.payload }
    case ADD_LEAD_STAGE_SUCCESS:
      state = { ...state, loading: false }
      break
    case ADD_LEAD_STAGE_ERROR:
      state = { ...state, error: action.payload, loading: false }
      break
    case GET_LEAD_STAGE:
      return { ...state, loading: true }
    case GET_LEAD_STAGE_SUCCESS:
      return { ...state, leadstages: action.payload, loading: false }
    case GET_LEAD_STAGE_FAIL:
      return { ...state, error: action.payload, loading: false }
    case UPDATE_LEAD_STAGE_SUCCESS:
      return {
        ...state,
        leadstages: state.leadstages.map(leadstage =>
          leadstage.id.toString() === action.payload.id.toString()
            ? { leadstage, ...action.payload }
            : leadstage
        ),
      }
    case UPDATE_LEAD_STATUS_FAIL:
      return { ...state, error: action.payload }
    case DELETE_LEAD_STAGE_SUCCESS:
      return { ...state, leadstage: action.payload }
    case DELETE_LEAD_STATUS_ERROR:
      return { ...state, error: action.payload }
    case ADD_TRANSACTION_TYPE_SUCCESS:
      state = { ...state, loading: false }
      break
    case ADD_TRANSACTION_TYPE_ERROR:
      state = { ...state, error: action.payload, loading: false }
      break
    case GET_TRANSACTION_TYPE:
      return { ...state, loading: true }
    case GET_TRANSACTION_TYPE_SUCCESS:
      return { ...state, transactonTypes: action.payload, loading: false }
    case GET_TRANSACTION_TYPE_FAIL:
      return { ...state, error: action.payload, loading: false }
    case UPDATE_TRANSACTION_TYPE_SUCCESS:
      return {
        ...state,
        transactonTypes: state.transactonTypes.map(transactonType =>
          transactonType.id.toString() === action.payload.id.toString()
            ? { transactonType, ...action.payload }
            : transactonType
        ),
      }
    case UPDATE_TRANSACTION_TYPE_FAIL:
      return { ...state, error: action.payload }
    case DELETE_TRANSACTION_TYPE_SUCCESS:
      return { ...state, transactonType: action.payload }
    case DELETE_TRANSACTION_TYPE_ERROR:
      return { ...state, error: action.payload }
    case ADD_TRANSACTION_REF_TYPE_SUCCESS:
      state = { ...state, loading: false }
      break
    case ADD_TRANSACTION_REF_TYPE_ERROR:
      state = { ...state, error: action.payload, loading: false }
      break
    case GET_TRANSACTION_REF_TYPE:
      return { ...state, loading: true }
    case GET_TRANSACTION_REF_TYPE_SUCCESS:
      return { ...state, transactonRefTypes: action.payload, loading: false }
    case GET_TRANSACTION_REF_TYPE_FAIL:
      return { ...state, error: action.payload, loading: false }
    case UPDATE_TRANSACTION_REF_TYPE_SUCCESS:
      return {
        ...state,
        transactonRefTypes: state.transactonRefTypes.map(transactonRefType =>
          transactonRefType.id.toString() === action.payload.id.toString()
            ? { transactonRefType, ...action.payload }
            : transactonRefType
        ),
      }
    case UPDATE_TRANSACTION_REF_TYPE_FAIL:
      return { ...state, error: action.payload }
    case DELETE_TRANSACTION_REF_TYPE_SUCCESS:
      return { ...state, transactonRefType: action.payload }
    case DELETE_TRANSACTION_REF_TYPE_ERROR:
      return { ...state, error: action.payload }
    case ADD_TRANSACTION_COMMISSION_TYPE_SUCCESS:
      state = { ...state, loading: false }
      break
    case ADD_TRANSACTION_COMMISSION_TYPE_ERROR:
      state = { ...state, error: action.payload, loading: false }
      break
    case GET_TRANSACTION_COMMISSION_TYPE:
      return { ...state, loading: true }
    case GET_TRANSACTION_COMMISSION_TYPE_SUCCESS:
      return { ...state, transactionCommTypes: action.payload, loading: false }
    case GET_TRANSACTION_COMMISSION_TYPE_FAIL:
      return { ...state, error: action.payload, loading: false }
    case UPDATE_TRANSACTION_COMMISSION_TYPE_SUCCESS:
      return {
        ...state,
        transactionCommTypes: state.transactionCommTypes.map(transactionCommType =>
          transactionCommType.id.toString() === action.payload.id.toString()
            ? { transactionCommType, ...action.payload }
            : transactionCommType
        ),
      }
    case UPDATE_TRANSACTION_COMMISSION_TYPE_FAIL:
      return { ...state, error: action.payload }
    case DELETE_TRANSACTION_COMMISSION_TYPE_SUCCESS:
      return { ...state, transactionCommType: action.payload }
    case DELETE_TRANSACTION_COMMISSION_TYPE_ERROR:
      return { ...state, error: action.payload }
    case ADD_TRANSACTION_STATUS_TYPE_SUCCESS:
      state = { ...state, loading: false }
      break
    case ADD_TRANSACTION_STATUS_TYPE_ERROR:
      state = { ...state, error: action.payload, loading: false }
      break
    case GET_TRANSACTION_STATUS_TYPE:
      return { ...state, loading: true }
    case GET_TRANSACTION_STATUS_TYPE_SUCCESS:
      return { ...state, transStatusTypes: action.payload, loading: false }
    case GET_TRANSACTION_STATUS_TYPE_FAIL:
      return { ...state, error: action.payload, loading: false }
    case UPDATE_TRANSACTION_STATUS_TYPE_SUCCESS:
      return {
        ...state,
        transStatusTypes: state.transStatusTypes.map(transStatusType =>
          transStatusType.id.toString() === action.payload.id.toString()
            ? { transStatusType, ...action.payload }
            : transStatusType
        ),
      }
    case UPDATE_TRANSACTION_STATUS_TYPE_FAIL:
      return { ...state, error: action.payload }
    case DELETE_TRANSACTION_STATUS_TYPE_SUCCESS:
      return { ...state, transStatusType: action.payload }
    case DELETE_TRANSACTION_STATUS_TYPE_ERROR:
      return { ...state, error: action.payload }
    case GET_LISTING_TYPE:
      return { ...state, loading: true }
    case GET_LISTING_TYPE_SUCCESS:
      return { ...state, listingtypes: action.payload, loading: false }
    case GET_LISTING_TYPE_FAIL:
      return { ...state, error: action.payload, loading: false }
    case GET_LISTING_STATUS:
      return { ...state, loading: true }
    case GET_LISTING_STATUS_SUCCESS:
      return { ...state, listingstatuses: action.payload, loading: false }
    case GET_LISTING_STATUS_ERROR:
      return { ...state, error: action.payload, loading: false }
    case GET_SHOWING_STATUS:
      return { ...state, loading: true }
    case GET_SHOWING_STATUS_SUCCESS:
      return { ...state, showingstatuses: action.payload, loading: false }
    case GET_SHOWING_STATUS_ERROR:
      return { ...state, error: action.payload, loading: false }
    case GET_EMAIL_LIST_TYPE:
      return { ...state, loading: true }
    case GET_EMAIL_LIST_TYPE_SUCCESS:
      return { ...state, emaillisttypes: action.payload, loading: false }
    case GET_EMAIL_LIST_TYPE_ERROR:
      return { ...state, error: action.payload, loading: false }
    case GET_EMAIL_LIST_TARGET:
      return { ...state, loading: true }
    case GET_EMAIL_LIST_TARGET_SUCCESS:
      return { ...state, emaillisttargets: action.payload, loading: false }
    case GET_EMAIL_LIST_TARGET_ERROR:
      return { ...state, error: action.payload, loading: false }
    case GET_CAMPAIGN_EMAIL_LIST:
      return { ...state, loading: true }
    case GET_CAMPAIGN_EMAIL_LIST_SUCCESS:
      return { ...state, campaignemaillists: action.payload, loading: false }
    case GET_CAMPAIGN_EMAIL_LIST_ERROR:
      return { ...state, error: action.payload, loading: false }
      case GET_APP_BY_PAGE_TYPE:
        return { ...state, loading: true }
      case GET_APP_BY_PAGE_TYPE_SUCCESS:
        return { ...state, appointment: action.payload, loading: false }
      case GET_APP_BY_PAGE_TYPE_FAIL:
        return { ...state, error: action.payload, loading: false }
    default:
      state = { ...state }
      break
  }
  return state
}

export default AppoinmentObject
